import React, { Component } from "react";
import { MapPin } from "lucide-react";

import CopyInput from "./CopyInput";
import PlacesV2Info from "./PlacesV2Info";

// Static map image fetched through the plugin backend, which holds the only
// Google key. Replaces the interactive map that needed a public browser key.
const GMap = ({ geometry }) => {
	const { lat, lng } = (geometry && geometry.location) || {};
	if (!lat || !lng) {
		return null;
	}
	const pluginUrl =
		(window.wpApiSettings && window.wpApiSettings.pluginUrl) ||
		"/wp-content/plugins/wp-id-generator/";
	const src = `${pluginUrl}backend/public/static-map.php?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;

	// If the image fails, fetch the same URL to surface the backend's JSON error in the console.
	const onError = async (e) => {
		e.currentTarget.style.display = "none";
		try {
			const res = await fetch(src, { credentials: "same-origin" });
			const text = await res.text();
			console.error(`[IDGenerator] static map failed: HTTP ${res.status}`, text.slice(0, 300));
		} catch (err) {
			console.error("[IDGenerator] static map failed:", err);
		}
	};

	return (
		<a
			className="idg-gmap"
			href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
			target="_blank"
			rel="noopener noreferrer"
			style={{ display: "block", height: "100%", minHeight: 320 }}
		>
			<img
				src={src}
				alt="Map showing the business location"
				onError={onError}
				style={{ width: "100%", height: "100%", minHeight: 320, objectFit: "cover", borderRadius: 5, display: "block" }}
			/>
		</a>
	);
};

const Unit = ({ value, title, subTitle }) => (
	<div className="idg-unit">

		<div className="inner">
			{/* <img alt="" className="bl-unit-icon" src={`/wp-content/plugins/wp-id-generator/frontend/build/img/${img}.svg`} /> */}
			<div>
				<p className="unit-title">{title}</p>
				<p>{subTitle}</p>
			</div>
		</div>


		<CopyInput value={value} link={true} />
	</div>
);

class BusinessData extends Component {
	clear = () => this.props.onClear();

	render() {
		const { data, onReset } = this.props;

		const ids = data.ids || {};
		const links = data.links || {};

		return (
			<>
				<div className="idg-business-data idg-animate-me">

					<p className="pre-text">Useful Google Business Profile Links for:{" "}</p>
					<h3>{data.name}</h3>
					<p className="business-address"><MapPin size={14} />{data.formatted_address}</p>

					{/* Three column unit row */}
					<div className="idg-units-row">
						<Unit
							value={links.reviews}
							img="reviews"
							title="View Google Business Profile reviews"
							subTitle="Use this link to share your reviews with customers"
						/>
						<Unit
							value={links["write-review"]}
							img="add-review"
							title="Get more reviews"
							subTitle="Direct customers to leave a review for this business"
						/>
						<Unit
							value={links["knowledge-box"]}
							img="google"
							title="See your Google Business Profile in the SERP"
							subTitle="Link to a search results page containing the business location's Knowledge Panel"
						/>
					</div>

					{/* Map and Places section below */}
					<div className="idg-map-section idg-animate-me">
						<div className="idg-map">
							<GMap geometry={data.geometry} />
						</div>

						<div className="idg-map-sidebar">
							<PlacesV2Info data={data} onReset={onReset} showCardsOnly={true} />
						</div>
					</div>

					{/* Additional info sections below map */}
					<PlacesV2Info data={data} onReset={onReset} showDetailsOnly={true} />

					

				</div>

				<div className="idg-info">
					{/*eslint-disable-next-line*/}
					<a name="id-info" />

					<div className="idg-info-title">
						<p className="pre-text">Google ID information for: </p>
						<h5>{data.name}</h5>
						<p className="business-address"><MapPin size={14} />{data.formatted_address}</p>
					</div>


					<div className="idg-info-row">

						<div className="idg-card">
							<h4>Ludocid</h4>
							<div className="unit">
								<CopyInput value={ids.ludocid} />
							</div>
						</div>

						<div className="idg-card">
							<h4>Place ID</h4>
							<div className="unit">
								<CopyInput value={ids["place-id"]} />
							</div>
						</div>

						<div className="idg-card">
							<h4>FID</h4>
							<div className="unit">
								<CopyInput value={ids.fid} />
							</div>
						</div>
					</div>

				</div>

	
			</>
		);
	}
}

export default BusinessData;
